'use strict';exports.__esModule = true;var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _images_placeholder = require('../../../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _iconPdf = require('../../../../../../static/icons/icon-pdf.png');var _iconPdf2 = _interopRequireDefault(_iconPdf);
var _modifyImageLink = require('../../../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../../../../constants');
var _CellGallery = require('./CellGallery.scss');var _CellGallery2 = _interopRequireDefault(_CellGallery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

CellGalleryItem = function (_React$Component) {_inherits(CellGalleryItem, _React$Component);function CellGalleryItem() {var _temp, _this, _ret;_classCallCheck(this, CellGalleryItem);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    handleClick = function (evt) {return evt.stopPropagation();}, _temp), _possibleConstructorReturn(_this, _ret);}CellGalleryItem.prototype.

  render = function render() {var
    item = this.props.item;

    if (item.raw) {
      return (
        _react2.default.createElement('div', { className: _CellGallery2.default.raw, key: item.thumbnail },
          _react2.default.createElement('img', { alt: '', src: _iconPdf2.default }),
          _react2.default.createElement('a', { href: item.thumbnail, onClick: this.handleClick },
            item.name)));



    }

    return (
      _react2.default.createElement('div', { className: _CellGallery2.default.image, key: item.thumbnail },
        _react2.default.createElement('img', {
          alt: '',
          srcSet: '\n            ' + (

          (0, _modifyImageLink2.default)(
          item.thumbnail,
          _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default) + ' 350w,\n            ' + (



          (0, _modifyImageLink2.default)(
          item.thumbnail,
          _constants.imageModifierTypes.GALLERY_THUMBNAIL_MOBILE) || _images_placeholder2.default) + ' 600w\n          ',



          sizes: '(max-width: 767px) 600px, (min-width: 768px) 350px',
          src:
          (0, _modifyImageLink2.default)(
          item.thumbnail,
          _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default })));





  };return CellGalleryItem;}(_react2.default.Component);exports.default = CellGalleryItem;


CellGalleryItem.propTypes = {
  item: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellGallery/CellGalleryItem.js
// module id = 1219
// module chunks = 0